import { RootState } from 'redux/store'

export const supplierIdSelector = (state: RootState) =>
  state.authReducer.userData.companyId ||
  state.profileReducer.shortSupplierData.id

export const lastPageSelector = (state: RootState) =>
  state.commonReducer.lastPage
